export default __webpack_public_path__ + "static/media/loyalty-section-illustration.8b648df0.svg";